import * as Realm from 'realm-web';

const initRealm = (realAppId) => new Realm.App({ id: realAppId });

export default initRealm;
